import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarAlineas(api) {
    let parametros = {
      operacao: 'buscarAlineas'
    }
    
    let retorno = {};
    
    await api.santriGET('/rest/alinea', parametros, 10, true)
      .then(response => {
        retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
      })
      .catch(error => {
        retorno = Biblioteca.retornoRequisicao('S', error, undefined);
      })
  
  
      return retorno;
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/RAlinea.js